import AuthenLayout from "./AuthenLayout";
import PageLayout from "./PageLayout";
import PageLogoLayout from "./PageLogoLayout";
import SystemLayout from "./SystemLayout";

const EXPORT = {
  AuthenLayout,
  PageLayout,
  PageLogoLayout,
  SystemLayout,
};

export default EXPORT;
